<template>
  <div v-if="section.settings.text" class="sf-announcement mx-4 sm:mx-0 mb-6">
    <component
      :is="section.settings.link ? 'button' : 'div'"
      type="button"
      class="sf-announcement__bar w-full text-center px-4 py-3 text-sm font-semibold"
      :class="{ 'cursor-pointer hover:opacity-90 transition-opacity': section.settings.link }"
      :style="{
        backgroundColor: section.settings.backgroundColor || 'var(--sf-primary)',
        color: section.settings.textColor || '#ffffff'
      }"
      @click="onClick"
    >
      {{ section.settings.text }}
      <span v-if="section.settings.link" aria-hidden="true" class="ml-1">&rsaquo;</span>
    </component>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { AnnouncementSection } from '@/global/state/StorefrontState'
import { openStorefrontLink } from '../storefrontUtils'

/* global defineProps */
const props = defineProps<{ section: AnnouncementSection }>()
const router = useRouter()

function onClick() {
  openStorefrontLink(router, props.section.settings.link)
}
</script>

<style>
.sf-announcement__bar {
  border-radius: var(--sf-radius);
  font-family: var(--sf-font);
}
</style>
